export const getRisksNames = (riskNames: string[]) => {
    if (riskNames.length === 0) return '';
    if (riskNames.length === 1) return riskNames[0];
    return 'multiple risks';
};
